/* eslint-disable no-lone-blocks */
/* eslint-disable default-case */
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ShowVisibleNextGroup,
  addChatSimult,
  addChat,
  typingadd,
  addMonitoring,
  addMonitoringSimult,
  EditTypeMonitorings,
  EditTypeMonitoringm,
  removeUserMonitoring,
  ShowInfoDisplay,
  AlterScreen,
  EfectBlockUser,
} from "../actions";
import _ from "lodash";
import { Tooltip, Popover } from "../actions/Tippy";
import { ReactComponent as EMCURSO } from "../build/images/em-curso.svg";
import { ReactComponent as FALARATENDENTE } from "../build/images/falar-com-atendente.svg";
import { ReactComponent as SIGILOSA } from "../build/images/sigilosa.svg";
import { ReactComponent as SUSURRO } from "../build/images/sussurro.svg";
import { ReactComponent as MONITORAR } from "../build/images/monitorar.svg";
import { ReactComponent as INTERCALAR } from "../build/images/intercalar.svg";
import { ReactComponent as BLOQUEIO } from "../build/images/bloqueio.svg";
import { ReactComponent as WHATSAPP } from "../build/images/whatsapp_icon.svg";
import WHATSAPPICON from "../build/images/report/whatsapp_icon.png";
import FACEBOOK from "../build/images/report/facebook_icon.png";
import VOZ from "../build/images/report/icon_call.png";
import { InitialMonitoring, SharedScreen } from "../actions/websocket";
import TimeCounterChatInternal from "./TimeCounterChatInternal";
import { Tooltipp, Topover } from "../actions/Tippy";
import Moment, { duration } from "moment";
import monitoring from "../reducers/monitoring";
import MicroModal from "micromodal";

var checkFiltro = false;
var keycount = 1;

const mapDispatchToProps = (dispatch) => {
  return {
    ShowVisibleNextGroupIn: (post, temp) => {
      dispatch(ShowVisibleNextGroup(post, temp));
    },
    EditTypeMonitoring: (userout, line, screen) => {
      dispatch(EditTypeMonitorings(userout, line));
      dispatch(EditTypeMonitoringm(userout, line));
      if (screen === "Gestor") {
        dispatch(ShowInfoDisplay("Monitorias"));
        dispatch(AlterScreen("Monitorias"));
      }
    },
    InitialChat: (iduser, displayname, active, ramal) => {
      let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
      dispatch(
        addChatSimult(iduser, displayname, active, false, ramal, datatime)
      );
      dispatch(addChat(iduser, displayname, active, false, ramal, datatime));
      dispatch(typingadd(iduser, displayname));
      dispatch(ShowInfoDisplay("Atendentes"));
      dispatch(AlterScreen("Atendentes"));
    },
    EfectBlockUser: (userout, act, reason) => {
      dispatch(EfectBlockUser(userout, act, reason));
    },
    ShowInfoDisplay: (post) => {
      dispatch(ShowInfoDisplay(post));
    },
    InitialMonitoring: (userin, userout, name, line, ramal, screen) => {
      dispatch(addMonitoring(userout, name, line, ramal));
      dispatch(addMonitoringSimult(userout, name, line, ramal));
      if (line != "4") {
        const socket = InitialMonitoring(userin, userout, line, ramal);
      } else {
        const socket = SharedScreen(ramal);
      }
      if (screen === "Gestor") {
        dispatch(ShowInfoDisplay("Monitorias"));
        dispatch(AlterScreen("Monitorias"));
      }
    },
  };
};

const mapStateToProps = (state) => {
  return {
    DisplayNextGroup: state.displaynextgroup,
    gruposatd: state.groups,
    usersatd: state.agents,
    ChatSimult: state.chatsimult,
    InfoUsers: state.informationusers,
    MonitoringSimult: state.monitoringsimult,
    IPCurrent: state.ipcurrent,
  };
};

class Groups extends Component {
  constructor(props) {
    super(props);
    var storageGroup = localStorage.getItem("dashboard_monitoring_group") || [];
    if (storageGroup.length !== 0) {
      storageGroup = storageGroup.split(",").map(Number);
    }
    this.state = {
      expandGroup: [],
      expandUser: [],
      buttonFilterGrupo: false,
      typeGrupo: storageGroup,
      markallgroups: true,
      filterAgent: "",
      keyGen: [],
      lsgruposatd: [],
      auxkeyGen: [],
      filterGroup: "",
      RetractExpand: "Expandir todos",
      lsusersatd: [],
      expandcollapse: "expand",
      filtrogrupo: [],
      actdesb: "1001",
      act: "1",
    };
  }

  ShowVisible() {
    this.props.ShowVisibleNextGroupIn(false, false);
  }

  componentDidMount() {
    this.setState({
      RetractExpand: "Expandir todos",
      expandcollapse: "expand",
      queueid: -1,
      filter: "",
      unfold: "unfold_more",
    });
  }

  DisplayDetails(e) {
    e.preventDefault();
    this.setState({ buttonRetract: !this.state.buttonRetract });
    let newState = this.state.buttonRetract
      ? {
          RetractExpand: "Expandir Todos",
          expandcollapse: "expand",
          unfold: "unfold_more",
        }
      : {
          RetractExpand: "Retrair Todos",
          expandcollapse: "collapse",
          unfold: "unfold_less",
          expandGroup: [],
          expandUser: [],
        };
    this.setState(newState);
  }

  checkExpandGroup(e, idgroup) {
    var checkClick =
      this.state.expandGroup.indexOf(idgroup) != -1 ? true : false;
    if (!checkClick) {
      this.setState({
        expandGroup: this.state.expandGroup.concat([idgroup]),
      });
    } else {
      this.setState({
        expandGroup: this.state.expandGroup.filter(function (val) {
          return val != idgroup;
        }),
      });
    }
  }

  checkExpandUser(e, iduser) {
    var checkClick = this.state.expandUser.indexOf(iduser) != -1 ? true : false;

    if (!checkClick) {
      this.setState({
        expandUser: this.state.expandUser.concat([iduser]),
      });
    } else {
      this.setState({
        expandUser: this.state.expandUser.filter(function (val) {
          return val != iduser;
        }),
      });
    }
  }

  DisplayFilterGrupos(e) {
    this.setState({ buttonFilterGrupo: !this.state.buttonFilterGrupo });
  }

  getFilterGrupo(e, idgrupo) {
    let typeGrupo = [];
    if (e.target.checked) {
      this.setState({
        typeGrupo: this.state.typeGrupo.concat([idgrupo]),
      });
      typeGrupo = this.state.typeGrupo.concat([idgrupo]);
    } else {
      this.setState({
        typeGrupo: this.state.typeGrupo.filter(function (val) {
          return val != idgrupo;
        }),
      });
      typeGrupo = this.state.typeGrupo.filter(function (val) {
        return val != idgrupo;
      });
    }
    localStorage.setItem("dashboard_monitoring_group", typeGrupo);
  }

  changeAgentGroup(e, teste) {
    this.setState({ filterAgent: e.target.value });
    if (e.target.value != "") {
      this.setState({ buttonRetract: true });
      let newState = this.state.buttonRetract
        ? {
            RetractExpand: "Expandir Todos",
            expandcollapse: "expand",
            unfold: "unfold_more",
          }
        : {
            RetractExpand: "Retrair Todos",
            expandcollapse: "collapse",
            unfold: "unfold_less",
            expandGroup: [],
          };
      this.setState(newState);
    } else {
      this.setState({ buttonRetract: false });
      let newState = this.state.buttonRetract
        ? {
            RetractExpand: "Expandir Todos",
            expandcollapse: "expand",
            unfold: "unfold_more",
          }
        : {
            RetractExpand: "Retrair Todos",
            expandcollapse: "collapse",
            unfold: "unfold_less",
            expandGroup: [],
          };
      this.setState(newState);
    }
    if (e.target.value != "") {
      this.setState({ keyGen: [] });
    }
    if (e.target.value === "") {
      this.setState({ keyGen: this.state.auxkeyGen });
    }
  }

  renderPopoverDial = (e, direcao, cliente) => (
    <div className="context-menu" id="drop-em-curso">
      <ul className="context-menu__list">
        <li className="em-curso__item">
          {/* <div className="em-curso__item__img">
              <WHATSAPP/>
            </div>     */}
          <div className="content">
            <div className="content__title">Ocupação: {direcao}</div>
            <div className="content__text">Cliente: {cliente}</div>
          </div>
        </li>
      </ul>
    </div>
  );

  InitialChat(e, chatsimult, user) {
    let erro = 0;
    if (chatsimult.length != 0) {
      chatsimult.map((chat) => {
        if (parseInt(chat.iduserout) === parseInt(user.iduser)) {
          erro = 1;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        this.props.ShowInfoDisplay("Atendentes");
      } else {
        this.props.InitialChat(
          parseInt(user.iduser),
          user.label,
          true,
          user.ramal
        );
      }
    } else {
      this.props.InitialChat(
        parseInt(user.iduser),
        user.label,
        true,
        user.ramal
      );
    }
  }

  InitialMonitoring(
    e,
    userin,
    userout,
    name,
    monitoringsimult,
    line,
    ramal,
    screen
  ) {
    let erro = 0;
    let auxline;
    if (monitoringsimult.length != 0) {
      monitoringsimult.map((monitoring) => {
        if (parseInt(monitoring.userout) === parseInt(userout)) {
          erro = 1;
          auxline = monitoring.line;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        if (auxline != line) {
          this.props.EditTypeMonitoring(userout, line, screen);
        }
      } else {
        this.props.InitialMonitoring(
          userin,
          userout,
          name,
          line,
          ramal,
          screen
        );
      }
    } else {
      this.props.InitialMonitoring(userin, userout, name, line, ramal, screen);
    }
  }

  showModal(e, userout, action, reasonaction, duration) {
    if (action === "BQSUPER") {
      MicroModal.show("modal__desbloqueio");
      duration = duration.split(" ");
      let horaaction = duration[1].split("-");
      horaaction = horaaction[0];
      duration = duration[0];
      this.setState({
        userout: userout,
        horaaction: horaaction,
        duration: duration,
        reasonaction: reasonaction,
        act: "1001",
        actdesb: "1001",
      });
    } else {
      MicroModal.show("modal__bloqueio");
      this.setState({ userout: userout, act: "1" });
    }
  }

  ActionUserSup(e, modal) {
    let reason = document.getElementById("anotc-add__textarea__input").value;
    this.props.EfectBlockUser(this.state.userout, this.state.act, reason);
    MicroModal.close(modal);
  }

  ActionUserSupDesbloq(e, modal) {
    let reason = document.getElementById(
      "anotc-add__textarea__input-desb"
    ).value;
    this.props.EfectBlockUser(this.state.userout, this.state.act, reason);
    MicroModal.close(modal);
  }

  AlterBlockAction(e, value) {
    this.setState({ act: value });
    if (value === "1") {
      document.getElementById("logout-atd").checked = false;
    } else {
      document.getElementById("block-atd").checked = false;
    }
  }

  AlterBlockActionDesb(e, value) {
    this.setState({ actdesb: value });
    if (value === "1001") {
      document.getElementById("radio-22").checked = false;
    } else {
      document.getElementById("radio-11").checked = false;
    }
  }

  actionMarkAllGroups(e, groups) {
    let array = [];
    let filters = [];
    this.setState({ markallgroups: !this.state.markallgroups });
    if (this.state.markallgroups) {
      array = groups;
      for (let i = 0; i < array.length; i++) {
        var myCheckbox = document.getElementById("inputgrupo" + array[i].id);
        myCheckbox.checked = true;
        filters = filters.concat([array[i].id]);
      }
      this.setState({
        typeGrupo: filters,
      });
      localStorage.setItem("dashboard_monitoring_group", filters);
    } else {
      array = groups;
      for (let i = 0; i < array.length; i++) {
        var myCheckbox = document.getElementById("inputgrupo" + array[i].id);
        myCheckbox.checked = false;
      }
      this.setState({ typeGrupo: [] });
      localStorage.setItem("dashboard_monitoring_group", []);
    }
  }

  render() {
    const {
      DisplayNextGroup,
      gruposatd,
      usersatd,
      ChatSimult,
      InfoUsers,
      MonitoringSimult,
      screen,
      IPCurrent,
    } = this.props;

    var filter = [];

    if (DisplayNextGroup.length != 0) {
      if (DisplayNextGroup.displaynextgroup === true) {
        this.state.visible = " active";
      } else if (
        DisplayNextGroup.displaynextgroup === false ||
        DisplayNextGroup.displaynextgroup === "ocultar"
      ) {
        this.state.visible = " w-20";
      } else {
        this.state.visible = " w-20";
      }
    }

    if (gruposatd.length != 0) {
      this.state.lsgruposatd = gruposatd.groups;
      this.state.filtrogrupo = gruposatd.groups;

      if (this.state.typeGrupo != "") {
        this.state.lsgruposatd = this.state.lsgruposatd.filter((lsgrupo) =>
          this.state.typeGrupo.includes(parseInt(lsgrupo.id))
        );
      }

      if (this.state.keyGen != "") {
        this.state.lsgruposatd = this.state.lsgruposatd.filter((group) =>
          this.state.keyGen.includes(group.id)
        );
      }
    } else {
      this.state.lsgruposatd = [];
    }

    if (usersatd.length != 0) {
      this.state.lsusersatd = usersatd;
    } else {
      this.state.lsusersatd = [];
    }

    let arrayFiltro = [];

    const list = this.state.lsusersatd || [];
    this.state.lsusersatd = _.filter(list, (agent) => {
      let arrayAgent = [
        agent.username,
        agent.desc_grupo,
        agent.ramal,
        agent.razao_bloqueio,
      ];
      return !_.isEmpty(this.state.filterAgent)
        ? _.lowerCase(arrayAgent).indexOf(_.lowerCase(this.state.filterAgent)) >
            -1
        : true;
    });

    {
      this.state.lsusersatd.map((user) =>
        (() => {
          filter = filter.concat([user.id_grupo]);
        })()
      );
    }

    if (this.state.lsgruposatd != 0) {
      this.state.lsgruposatd = this.state.lsgruposatd.filter((group) =>
        filter.includes(group.id)
      );
    }

    this.state.lsgruposatd = this.state.lsgruposatd.filter(
      (agent) => agent.iduser !== InfoUsers.id
    );

    return (
      <div
        className={"column-model small-column" + this.state.visible}
        id="monitoria"
      >
        <div className="column-model__header">
          <div
            className="column-model__header__title"
            onClick={(event) => this.ShowVisible(event)}
          >
            <button
              type="submit"
              className="column-model__header__title__btn tippy-default"
              data-tippy-theme="light"
              data-tippy-content="Ocultar"
            >
              <i className="material-icons">arrow_back</i>
            </button>
            <div className="text">Monitorar</div>
          </div>

          <div className="column-model__header__select">
            <div
              className={
                this.state.buttonFilterGrupo
                  ? "select with-icons with-footer-action active"
                  : "select with-icons with-footer-action"
              }
            >
              <button
                className="select__btn"
                type="button"
                onClick={(event) => this.DisplayFilterGrupos(event)}
                data-pausa="Atendimento Presencial Cliente"
              >
                Filtros
                <i className="select__icon material-icons">
                  keyboard_arrow_right
                </i>
              </button>
              <div className="options">
                <ul>
                  <li key={"99999999999"}>
                    <input
                      type="checkbox"
                      name="inputgrupo9999"
                      id="inputgrupo9999"
                      onChange={(event) =>
                        this.actionMarkAllGroups(event, this.state.filtrogrupo)
                      }
                    />
                    <label htmlFor="inputgrupo9999">
                      {this.state.markallgroups
                        ? "Marcar Todos"
                        : "Desmarcar Todos"}
                    </label>
                  </li>
                  {this.state.filtrogrupo.map((group, index) =>
                    (() => {
                      if (checkFiltro == false) {
                        arrayFiltro.push(parseInt(group.id));
                      }
                      return (
                        <li key={index}>
                          <input
                            type="checkbox"
                            name={"inputgrupo" + group.id}
                            id={"inputgrupo" + group.id}
                            defaultChecked={
                              this.state.typeGrupo.findIndex(function (val) {
                                return val === group.id;
                              }) !== -1
                                ? true
                                : false
                            }
                            onChange={(event) =>
                              this.getFilterGrupo(event, parseInt(group.id))
                            }
                          />
                          <label htmlFor={"inputgrupo" + group.id}>
                            {group.name}
                          </label>
                        </li>
                      );
                    })()
                  )}
                </ul>
                <a
                  className="btn btn-primary"
                  id="apply-filters"
                  onClick={(event) => this.DisplayFilterGrupos(event)}
                >
                  Fechar
                </a>
              </div>
            </div>
          </div>
          {/* { (() => {                               
                          if(checkFiltro==false){
                              this.state.typeGrupo = arrayFiltro;
                              checkFiltro=true;
                          }
                        }
                  )()       
                } */}
          <div action="#" className="form-full">
            <div className="full-search">
              <input
                type="text"
                name="client-search"
                id="client-search"
                onChange={(event) => this.changeAgentGroup(event, "teste")}
                placeholder="Pesquise um operador..."
              />
              <button type="submit" className="full-search__btn">
                <i className="material-icons">search</i>
              </button>
            </div>
          </div>
        </div>

        <div className="column-model__body">
          <a
            className="column-model__body__fold"
            data-action={this.state.expandcollapse}
            onClick={this.DisplayDetails.bind(this)}
            id="expand-all-group"
          >
            <i className="material-icons">{this.state.unfold}</i>
            <p className="text">{this.state.RetractExpand}</p>
          </a>
          <div className="column-model__body__content">
            <div className="list">
              {this.state.lsgruposatd.map((group) =>
                (() => (
                  <div className="item item--groups" key={keycount++}>
                    <div
                      className={
                        this.state.buttonRetract ||
                        this.state.expandGroup.indexOf(group.id) != -1
                          ? "inner inner__atendentes active"
                          : "inner inner__atendentes"
                      }
                      key={group.id}
                    >
                      <div className="title title__atendentes">
                        <div className="title__top">
                          <div
                            className="about-user"
                            onClick={(event) =>
                              this.checkExpandGroup(event, group.id)
                            }
                          >
                            <div className="group is-poppings">
                              {group.name}
                            </div>
                          </div>
                          <div className="actions">
                            <a href="#" className="info" data-tippy="">
                              <i className="material-icons">more_vert</i>
                            </a>
                            <a href="#" className="info">
                              <i
                                onClick={(event) =>
                                  this.checkExpandGroup(event, group.id)
                                }
                                className="chevron_right material-icons"
                              >
                                chevron_right
                              </i>
                            </a>
                          </div>
                        </div>
                      </div>
                      {this.state.lsusersatd.map((user, index) =>
                        (() => {
                          var checkAtdUser = false;
                          if (parseInt(group.id) == parseInt(user.id_grupo)) {
                            let classStatus = "";
                            {
                              (() => {
                                if (
                                  user.status_sip === "LV" &&
                                  user.status === "AT"
                                ) {
                                  return (classStatus = "item-atendentes");
                                } else if (
                                  user.status_sip === "LV" &&
                                  user.status === "RV"
                                ) {
                                  return (classStatus = "item-atendentes");
                                } else if (
                                  user.status_sip === "RV" &&
                                  user.status === "ATOS"
                                ) {
                                  return (classStatus = "item-atendentes");
                                } else if (
                                  user.status_sip === "AT" &&
                                  user.razao_bloqueio != "AT"
                                ) {
                                  return (classStatus = "item-atendentes");
                                } else if (
                                  user.status_sip === "CHND" &&
                                  user.razao_bloqueio != "CHND"
                                ) {
                                  return (classStatus = "item-atendentes");
                                } else if (
                                  user.status_sip === "BQ" &&
                                  user.razao_bloqueio != ""
                                ) {
                                  return (classStatus = "item-atendentes");
                                } else if (
                                  user.status_sip === "ACW" &&
                                  user.status === "ACW"
                                ) {
                                  return (classStatus = "item-atendentes");
                                } else if (
                                  user.status_sip === "LV" &&
                                  user.status === "LV"
                                ) {
                                  return (classStatus = "item-atendentes");
                                } else if (
                                  user.status_sip === "BQSUPER" &&
                                  user.status === "BQSUPER"
                                ) {
                                  return (classStatus = "item-atendentes");
                                } else {
                                  return (classStatus =
                                    "item-atendentes item-atendentes--offline");
                                }
                              })();
                            }
                            return (
                              <div className="details-atendentes" key={index}>
                                <div className={classStatus}>
                                  <div className="title">
                                    <div className="title__top">
                                      <div className="about-user about-user--item">
                                        <div
                                          className="nome"
                                          key={user.iduser}
                                          onClick={(event) =>
                                            this.checkExpandUser(
                                              event,
                                              user.iduser
                                            )
                                          }
                                        >
                                          <span className="nome__text nome__text--tec is-poppins">
                                            {" "}
                                            {user.label}
                                          </span>
                                        </div>
                                        {(() => {
                                          if (
                                            user.status_sip === "LV" &&
                                            user.status === "LV"
                                          ) {
                                            checkAtdUser = false;
                                            return (
                                              <div
                                                className="status-time pausa-content pausa-btn--livre tippy-default"
                                                data-tippy-content="media"
                                              >
                                                <i className="material-icons">
                                                  call
                                                </i>
                                                Livre
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "BQSUPER" &&
                                            user.status === "BQSUPER"
                                          ) {
                                            checkAtdUser = false;
                                            return (
                                              <div
                                                className="status-time tippy-default pausa-content pausa-btn--pausado"
                                                data-tippy-content="media"
                                              >
                                                <i className="material-icons">
                                                  timer_off
                                                </i>
                                                Pausado
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "ACW" &&
                                            user.status === "ACW"
                                          ) {
                                            checkAtdUser = false;
                                            return (
                                              <div
                                                className="status-time tippy-default pausa-content pausa-btn--after-call"
                                                data-tippy-content="media"
                                              >
                                                <i className="material-icons">
                                                  timer
                                                </i>
                                                AfterCallWork
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "BQ" &&
                                            user.status === "LV"
                                          ) {
                                            checkAtdUser = false;
                                            return (
                                              <div
                                                className="status-time tippy-default pausa-content pausa-btn--pausado"
                                                data-tippy-content="media"
                                              >
                                                <i className="material-icons">
                                                  timer_off
                                                </i>
                                                Pausado
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "BQ" &&
                                            user.status === "BQ"
                                          ) {
                                            checkAtdUser = false;
                                            return (
                                              <div
                                                className="status-time tippy-default pausa-content pausa-btn--pausado"
                                                data-tippy-content="media"
                                              >
                                                <i className="material-icons">
                                                  timer_off
                                                </i>
                                                Pausado
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "AT" &&
                                            user.razao_bloqueio != "AT"
                                          ) {
                                            checkAtdUser = true;
                                            return (
                                              <div
                                                className="status-time pausa-content pausa-btn--chmd-ativa tippy-default"
                                                data-tippy-content="media"
                                              >
                                                {(() => {
                                                  if (user.mediaid === "1") {
                                                    return (
                                                      <>
                                                        <img
                                                          src={VOZ}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else if (
                                                    user.mediaid === "4"
                                                  ) {
                                                    return (
                                                      <>
                                                        <img
                                                          src={FACEBOOK}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else if (
                                                    user.mediaid === "5" ||
                                                    user.mediaid === 5
                                                  ) {
                                                    return (
                                                      <>
                                                        <img
                                                          src={WHATSAPPICON}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else {
                                                    return (
                                                      <>
                                                        <i className="material-icons">
                                                          phone_in_talk
                                                        </i>
                                                        Ativa
                                                      </>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "LV" &&
                                            user.status === "AT"
                                          ) {
                                            checkAtdUser = true;
                                            return (
                                              <div
                                                className="status-time pausa-content pausa-btn--chmd-ativa tippy-default"
                                                data-tippy-content="media"
                                              >
                                                {(() => {
                                                  if (user.mediaid === "1") {
                                                    return (
                                                      <>
                                                        <img
                                                          src={VOZ}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else if (
                                                    user.mediaid === "4"
                                                  ) {
                                                    return (
                                                      <>
                                                        <img
                                                          src={FACEBOOK}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else if (
                                                    user.mediaid === "5" ||
                                                    user.mediaid === 5
                                                  ) {
                                                    return (
                                                      <>
                                                        <img
                                                          src={WHATSAPPICON}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else {
                                                    return (
                                                      <>
                                                        <i className="material-icons">
                                                          phone_in_talk
                                                        </i>
                                                        Ativa
                                                      </>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "CHND" &&
                                            user.razao_bloqueio != "CHND"
                                          ) {
                                            checkAtdUser = true;
                                            return (
                                              <div
                                                className="status-time pausa-content pausa-btn--chmd-ativa tippy-default"
                                                data-tippy-content="media"
                                              >
                                                {(() => {
                                                  if (user.mediaid === "1") {
                                                    return (
                                                      <>
                                                        <img
                                                          src={VOZ}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else if (
                                                    user.mediaid === "4"
                                                  ) {
                                                    return (
                                                      <>
                                                        <img
                                                          src={FACEBOOK}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else if (
                                                    user.mediaid === "5" ||
                                                    user.mediaid === 5
                                                  ) {
                                                    return (
                                                      <>
                                                        <img
                                                          src={WHATSAPPICON}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else {
                                                    return (
                                                      <>
                                                        <i className="material-icons">
                                                          phone_in_talk
                                                        </i>
                                                        Ativa
                                                      </>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            );
                                          } else if (
                                            user.status === "CHND" &&
                                            user.status_sip != "LV"
                                          ) {
                                            checkAtdUser = true;
                                            return (
                                              <div
                                                className="status-time pausa-content pausa-btn--chmd-ativa tippy-default"
                                                data-tippy-content="media"
                                              >
                                                {(() => {
                                                  if (user.mediaid === "1") {
                                                    return (
                                                      <>
                                                        <img
                                                          src={VOZ}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else if (
                                                    user.mediaid === "4"
                                                  ) {
                                                    return (
                                                      <>
                                                        <img
                                                          src={FACEBOOK}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else if (
                                                    user.mediaid === "5" ||
                                                    user.mediaid === 5
                                                  ) {
                                                    return (
                                                      <>
                                                        <img
                                                          src={WHATSAPPICON}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else {
                                                    return (
                                                      <>
                                                        <i className="material-icons">
                                                          phone_in_talk
                                                        </i>
                                                        Ativa
                                                      </>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "RV" &&
                                            user.status === "ATOS"
                                          ) {
                                            checkAtdUser = true;
                                            return (
                                              <div
                                                className="status-time pausa-content pausa-btn--chmd-ativa tippy-default"
                                                data-tippy-content="media"
                                              >
                                                {(() => {
                                                  if (user.mediaid === "1") {
                                                    return (
                                                      <>
                                                        <img
                                                          src={VOZ}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else if (
                                                    user.mediaid === "4"
                                                  ) {
                                                    return (
                                                      <>
                                                        <img
                                                          src={FACEBOOK}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else if (
                                                    user.mediaid === "5" ||
                                                    user.mediaid === 5
                                                  ) {
                                                    return (
                                                      <>
                                                        <img
                                                          src={WHATSAPPICON}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else {
                                                    return (
                                                      <>
                                                        <i className="material-icons">
                                                          phone_in_talk
                                                        </i>
                                                        Ativa
                                                      </>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "LV" &&
                                            user.status === "RV"
                                          ) {
                                            checkAtdUser = true;
                                            return (
                                              <div
                                                className="status-time pausa-content pausa-btn--chmd-ativa tippy-default"
                                                data-tippy-content="media"
                                              >
                                                {(() => {
                                                  if (user.mediaid === "1") {
                                                    return (
                                                      <>
                                                        <img
                                                          src={VOZ}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else if (
                                                    user.mediaid === "4"
                                                  ) {
                                                    return (
                                                      <>
                                                        <img
                                                          src={FACEBOOK}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else if (
                                                    user.mediaid === "5" ||
                                                    user.mediaid === 5
                                                  ) {
                                                    return (
                                                      <>
                                                        <img
                                                          src={WHATSAPPICON}
                                                          width="10"
                                                          alt=""
                                                        />
                                                        Ativa
                                                      </>
                                                    );
                                                  } else {
                                                    return (
                                                      <>
                                                        <i className="material-icons">
                                                          phone_in_talk
                                                        </i>
                                                        Ativa
                                                      </>
                                                    );
                                                  }
                                                })()}
                                              </div>
                                            );
                                          } else if (user.status === null) {
                                            checkAtdUser = false;
                                            return (
                                              <div
                                                className="status-time pausa-content pausa-btn--inativo tippy-default"
                                                data-tippy-content="media"
                                              >
                                                <i className="material-icons">
                                                  call_end
                                                </i>
                                                Inativo
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === null &&
                                            user.status === "LV"
                                          ) {
                                            checkAtdUser = false;
                                            return (
                                              <div
                                                className="status-time pausa-content pausa-btn--inativo tippy-default"
                                                data-tippy-content="media"
                                              >
                                                <i className="material-icons">
                                                  call_end
                                                </i>
                                                Inativo
                                              </div>
                                            );
                                          } else {
                                            checkAtdUser = false;
                                            return (
                                              <div
                                                className="status-time pausa-content pausa-btn--inativo tippy-default"
                                                data-tippy-content="media"
                                              >
                                                <i className="material-icons">
                                                  call_end
                                                </i>
                                                Inativo
                                              </div>
                                            );
                                          }
                                        })()}
                                      </div>

                                      {(() => {
                                        let duracao = "";
                                        if (user.duration) {
                                          let arrayCompA =
                                            user.duration.split("-");
                                          let datatimeCompA = Moment().format(
                                            "YYYY/MM/DD HH:mm:ss"
                                          );
                                          var valorDiferenca = parseInt(
                                            Math.abs(
                                              Math.round(IPCurrent.difftime)
                                            )
                                          );

                                          if (
                                            parseInt(IPCurrent.difftime) < 0
                                          ) {
                                            datatimeCompA = Moment()
                                              .subtract(
                                                valorDiferenca,
                                                "seconds"
                                              )
                                              .format("YYYY/MM/DD HH:mm:ss");
                                          } else {
                                            datatimeCompA = Moment()
                                              .add(valorDiferenca, "seconds")
                                              .format("YYYY/MM/DD HH:mm:ss");
                                          }

                                          let dataStatusA = Moment(
                                            arrayCompA[0],
                                            "DD/MM/YYYY HH:mm:ss"
                                          ).format("YYYY/MM/DD HH:mm:ss");
                                          duracao = Moment(datatimeCompA).diff(
                                            dataStatusA,
                                            "seconds"
                                          );
                                        }
                                        if (user.status === null) {
                                          checkAtdUser = false;
                                          return (
                                            <div className="user-time active">
                                              <i className="material-icons">
                                                query_builder
                                              </i>{" "}
                                              <span className="time">
                                                00:00:00
                                              </span>
                                            </div>
                                          );
                                        } else if (
                                          user.status_sip === null &&
                                          user.status === "LV"
                                        ) {
                                          checkAtdUser = false;
                                          return (
                                            <div className="user-time active">
                                              <i className="material-icons">
                                                query_builder
                                              </i>{" "}
                                              <span className="time">
                                                00:00:00
                                              </span>
                                            </div>
                                          );
                                        } else {
                                          checkAtdUser = false;
                                          return (
                                            <div className="user-time active">
                                              <i className="material-icons">
                                                query_builder
                                              </i>{" "}
                                              <span className="time">
                                                <TimeCounterChatInternal
                                                  horario={parseInt(duracao)}
                                                  key={
                                                    user.iduser +
                                                    "_" +
                                                    user.status_sip
                                                  }
                                                />
                                              </span>
                                            </div>
                                          );
                                        }
                                      })()}

                                      <div className="actions">
                                        <div className="em-curso">
                                          {(() => {
                                            switch (checkAtdUser) {
                                              case true:
                                                return (
                                                  <Popover
                                                    trigger="click"
                                                    boundary="window"
                                                    placement="left"
                                                    multiple={true}
                                                    interactive={true}
                                                    content={this.renderPopoverDial(
                                                      this,
                                                      user.direcao,
                                                      user.speaknum
                                                    )}
                                                  >
                                                    <a className="i"></a>
                                                  </Popover>
                                                );
                                            }
                                          })()}
                                        </div>
                                        <Tooltipp content={"Enviar Mensagem"}>
                                          <a
                                            href="#"
                                            onClick={(event) =>
                                              this.InitialChat(
                                                event,
                                                ChatSimult,
                                                user
                                              )
                                            }
                                            className="info tippy-context-menu"
                                            data-tippy-placement="right"
                                            data-template="drop-em-curso"
                                          >
                                            <EMCURSO />
                                          </a>
                                        </Tooltipp>
                                        <Tooltipp
                                          content={"Falar com atendente"}
                                        >
                                          <a
                                            href="#"
                                            className="info tippy-default"
                                            onClick={(e) =>
                                              this.InitialMonitoring(
                                                e,
                                                InfoUsers.id,
                                                user.iduser,
                                                user.label,
                                                MonitoringSimult,
                                                "5",
                                                user.ramal,
                                                screen
                                              )
                                            }
                                            data-tippy-theme="light"
                                            data-tippy-placement="top"
                                            data-tippy-content="Falar com atendente"
                                          >
                                            <FALARATENDENTE />
                                          </a>
                                        </Tooltipp>

                                        <Tooltipp content={"Escuta sigilosa"}>
                                          <a
                                            href="#"
                                            onClick={(e) =>
                                              this.InitialMonitoring(
                                                e,
                                                InfoUsers.id,
                                                user.iduser,
                                                user.label,
                                                MonitoringSimult,
                                                "1",
                                                user.ramal,
                                                screen
                                              )
                                            }
                                            className="info tippy-default"
                                            data-tippy-theme="light"
                                            data-tippy-placement="top"
                                            data-tippy-content="Escuta sigilosa"
                                          >
                                            <SIGILOSA />
                                          </a>
                                        </Tooltipp>

                                        <Tooltipp content={"Sussurro"}>
                                          <a
                                            href="#"
                                            className="info tippy-default"
                                            onClick={(e) =>
                                              this.InitialMonitoring(
                                                e,
                                                InfoUsers.id,
                                                user.iduser,
                                                user.label,
                                                MonitoringSimult,
                                                "2",
                                                user.ramal,
                                                screen
                                              )
                                            }
                                            data-tippy-theme="light"
                                            data-tippy-placement="top"
                                            data-tippy-content="Sussurro"
                                          >
                                            <SUSURRO />
                                          </a>
                                        </Tooltipp>

                                        <Tooltipp content={"Intercalar"}>
                                          <a
                                            href="#"
                                            className="info tippy-default"
                                            onClick={(e) =>
                                              this.InitialMonitoring(
                                                e,
                                                InfoUsers.id,
                                                user.iduser,
                                                user.label,
                                                MonitoringSimult,
                                                "3",
                                                user.ramal,
                                                screen
                                              )
                                            }
                                            data-tippy-theme="light"
                                            data-tippy-placement="top"
                                            data-tippy-content="Intercalar"
                                          >
                                            <INTERCALAR />
                                          </a>
                                        </Tooltipp>

                                        {/* <Tooltipp content={'Monitorar'}>
                                                                      <a href="#" className="info tippy-default" data-tippy-theme="light" onClick={e => this.InitialMonitoring(e,InfoUsers.id,user.iduser,user.label,MonitoringSimult,'4',user.ramal,screen)} data-tippy-placement="top" data-tippy-content="Monitorar">
                                                                          <MONITORAR/>
                                                                      </a>
                                                                      </Tooltipp> */}

                                        <Tooltipp content={"Bloqueio"}>
                                          <a
                                            onClick={(event) =>
                                              this.showModal(
                                                event,
                                                user.iduser,
                                                user.status_sip,
                                                user.razao_bloqueio,
                                                user.duration
                                              )
                                            }
                                            href="#"
                                            className="info tippy-default"
                                            data-tippy-theme="light"
                                            data-tippy-placement="top"
                                            data-tippy-content="Bloqueio"
                                          >
                                            <BLOQUEIO />
                                          </a>
                                        </Tooltipp>
                                      </div>
                                      <div
                                        className={
                                          this.state.expandUser.indexOf(
                                            user.iduser
                                          ) != -1
                                            ? "details active"
                                            : "details"
                                        }
                                      >
                                        {(() => {
                                          let duracao = "";
                                          if (user.duration) {
                                            let arrayCompA =
                                              user.duration.split("-");
                                            let datatimeCompA = Moment().format(
                                              "YYYY/MM/DD HH:mm:ss"
                                            );
                                            var valorDiferenca = parseInt(
                                              Math.abs(
                                                Math.round(IPCurrent.difftime)
                                              )
                                            );

                                            if (
                                              parseInt(IPCurrent.difftime) < 0
                                            ) {
                                              datatimeCompA = Moment()
                                                .subtract(
                                                  valorDiferenca,
                                                  "seconds"
                                                )
                                                .format("YYYY/MM/DD HH:mm:ss");
                                            } else {
                                              datatimeCompA = Moment()
                                                .add(valorDiferenca, "seconds")
                                                .format("YYYY/MM/DD HH:mm:ss");
                                            }

                                            let dataStatusA = Moment(
                                              arrayCompA[0],
                                              "DD/MM/YYYY HH:mm:ss"
                                            ).format("YYYY/MM/DD HH:mm:ss");
                                            duracao = Moment(
                                              datatimeCompA
                                            ).diff(dataStatusA, "seconds");
                                          }
                                          if (
                                            user.status_sip === null ||
                                            user.status === null
                                          ) {
                                            return (
                                              <div className="item details__text">
                                                Status: Deslogado
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "LV" &&
                                            user.status === "LV"
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Status: Livre
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                    key={
                                                      user.iduser +
                                                      "_" +
                                                      user.status_sip
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "LV" &&
                                            user.status === "AT"
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Atendimento: Ativo
                                                </div>
                                                <div className="item details__text">
                                                  Atendendo: {user.speaknum}
                                                </div>
                                                <div className="item details__text">
                                                  Direção: {user.direcao}
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                    key={
                                                      user.iduser +
                                                      "_" +
                                                      user.status_sip
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "RV" &&
                                            user.status === "ATOS"
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Atendimento: Ativo
                                                </div>
                                                <div className="item details__text">
                                                  Atendendo: {user.speaknum}
                                                </div>
                                                <div className="item details__text">
                                                  Direção: {user.direcao}
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                    key={
                                                      user.iduser +
                                                      "_" +
                                                      user.status_sip
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "LV" &&
                                            user.status === "RV"
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Atendimento: Discando
                                                </div>
                                                <div className="item details__text">
                                                  Atendendo: {user.speaknum}
                                                </div>
                                                <div className="item details__text">
                                                  Direção: {user.direcao}
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                    key={
                                                      user.iduser +
                                                      "_" +
                                                      user.status_sip
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "BQ" &&
                                            user.razao_bloqueio != ""
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Status: Pausado
                                                </div>
                                                <div className="item details__text">
                                                  Pausa: {user.razao_bloqueio}
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                    key={
                                                      user.iduser +
                                                      "_" +
                                                      user.status_sip
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "ACW" &&
                                            user.status === "ACW"
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Status: AfterCallWork
                                                </div>
                                                <div className="item details__text">
                                                  Telefone:{" "}
                                                  {user.razao_bloqueio}
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                    key={
                                                      user.iduser +
                                                      "_" +
                                                      user.status_sip
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            );
                                          } else if (
                                            user.status_sip === "CHND" &&
                                            user.razao_bloqueio != "CHND"
                                          ) {
                                            return (
                                              <div>
                                                <div className="item details__text">
                                                  Atendimento: Chamando
                                                </div>
                                                <div className="item details__text">
                                                  Atendendo: {user.speaknum}
                                                </div>
                                                <div className="item details__text">
                                                  Direção: {user.direcao}
                                                </div>
                                                <div className="item details__text">
                                                  Duração:{" "}
                                                  <TimeCounterChatInternal
                                                    horario={parseInt(duracao)}
                                                    key={
                                                      user.iduser +
                                                      "_" +
                                                      user.status_sip
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            );
                                          }
                                        })()}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })()
                      )}
                    </div>
                  </div>
                ))()
              )}
            </div>
          </div>
        </div>
        <div
          className="modal micromodal-slide"
          id="modal__bloqueio"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__bloqueio__title"
            >
              <header className="modal__header">
                <h2 className="modal__title" id="modal__bloqueio__title">
                  Bloqueio
                </h2>

                <button
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                ></button>
              </header>
              <div className="modal__header__bottom-line"></div>
              <main
                className="modal__content modal__content--small"
                id="modal__bloqueio__content"
              >
                <div className="modal__content__user-details__content">
                  <form action="" className="modal__content__form">
                    <div className="modal__content__form__group modal__content__form__group--col-8">
                      <div className="modal__content--left">
                        <h3 className="modal-box__warning is-poppins">
                          Razão do bloqueio <br />
                        </h3>

                        <p className="modal-box__message">
                          Descreva a razão do bloqueio para o atendente
                        </p>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-8"></div>
                      <div className="radio-content radio-content--column">
                        <div className="radio-button">
                          <input
                            type="radio"
                            id="block-atd"
                            name="block-atd"
                            onClick={(event) =>
                              this.AlterBlockAction(event, "1")
                            }
                            defaultChecked={
                              this.state.act === "1" ? true : false
                            }
                          />
                          <label htmlFor="block-atd">
                            <span>
                              <div className="mask"></div>
                            </span>

                            <div className="text">Bloquear</div>
                          </label>
                        </div>

                        <div className="radio-button">
                          <input
                            type="radio"
                            id="logout-atd"
                            name="logout-atd"
                            onClick={(event) =>
                              this.AlterBlockAction(event, "2")
                            }
                            defaultChecked={
                              this.state.act === "2" ? true : false
                            }
                          />
                          <label htmlFor="logout-atd">
                            <span>
                              <div className="mask"></div>
                            </span>

                            <div className="text">Logout do atendente</div>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-8">
                      <div className="anotc-add__textarea">
                        <textarea
                          name="anotc-add__textarea__input"
                          id="anotc-add__textarea__input"
                          className="anotc-add__textarea__input"
                        ></textarea>
                      </div>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-1"></div>
                    <div className="modal__content__form__group modal__content__form__group--col-3">
                      <a
                        className="modal__content__form__group__button modal__content__form__group__button--white"
                        data-micromodal-close
                      >
                        Cancelar
                      </a>
                    </div>
                    <div className="modal__content__form__group modal__content__form__group--col-3">
                      <a
                        className="modal__content__form__group__button "
                        onClick={(event) =>
                          this.ActionUserSup(event, "modal__bloqueio")
                        }
                      >
                        OK
                      </a>
                    </div>
                  </form>
                </div>
              </main>
            </div>
          </div>
        </div>
        <div
          className="modal micromodal-slide"
          id="modal__desbloqueio"
          aria-hidden="true"
          role="dialog"
        >
          <div className="modal__overlay" tabIndex="-1">
            <div
              className="modal__container"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal__desbloqueio__title"
            >
              <header className="modal__header">
                <h2 className="modal__title" id="modal__desbloqueio__title">
                  Desbloqueio
                </h2>

                <button
                  className="modal__close"
                  aria-label="Close modal"
                  data-micromodal-close
                ></button>
              </header>
              <div className="modal__header__bottom-line"></div>
              <main
                className="modal__content modal__content--small"
                id="modal__desbloqueio__content"
              >
                <div className="modal__content__user-details__content">
                  <form action="" className="modal__content__form">
                    <div className="modal__content__form__group modal__content__form__group--col-8">
                      <div className="modal__content--left">
                        <h3 className="modal-box__warning is-poppins">
                          Razão do bloqueio <br />
                        </h3>

                        <p className="modal-box__message">
                          Descreva a razão do desbloqueio para o atendente
                        </p>
                      </div>

                      <div className="modal__content__form__group modal__content__form__group--col-8"></div>
                      <div className="radio-content radio-content--column">
                        <div className="radio-button">
                          <input
                            type="radio"
                            id="radio-11"
                            name="radio-11"
                            onClick={(event) =>
                              this.AlterBlockActionDesb(event, "1001")
                            }
                            defaultChecked={
                              this.state.actdesb === "1001" ? "checked" : ""
                            }
                          />
                          <label htmlFor="radio-11">
                            <span>
                              <div className="mask"></div>
                            </span>

                            <div className="text">Desbloquear</div>
                          </label>
                        </div>

                        <div className="radio-button">
                          <input
                            type="radio"
                            id="radio-22"
                            name="radio-22"
                            onClick={(event) =>
                              this.AlterBlockActionDesb(event, "3")
                            }
                            defaultChecked={
                              this.state.actdesb === "3" ? "checked" : ""
                            }
                          />
                          <label htmlFor="radio-22">
                            <span>
                              <div className="mask"></div>
                            </span>

                            <div className="text">Logout do atendente</div>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-8">
                      <div className="modal__content__form__group__desc">
                        {/* <div className="modal__content__form__group__desc__item">
                            <strong>Bloqueado por:</strong>
                            Gabriel Ferreira
                          </div> */}
                        <div className="modal__content__form__group__desc__item">
                          <strong>Data de bloqueio:</strong>
                          {" " + this.state.duration}
                        </div>
                        <div className="modal__content__form__group__desc__item">
                          <strong>Hora de bloqueio:</strong>
                          {" " + this.state.horaaction}
                        </div>
                        <div className="modal__content__form__group__desc__item">
                          <strong>Razão do bloqueio:</strong>
                          <span>{" " + this.state.reasonaction}</span>
                        </div>
                      </div>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-8">
                      <div className="anotc-add__textarea">
                        <textarea
                          name="anotc-add__textarea__input"
                          id="anotc-add__textarea__input-desb"
                          className="anotc-add__textarea__input"
                        ></textarea>
                      </div>
                    </div>

                    <div className="modal__content__form__group modal__content__form__group--col-1"></div>
                    <div className="modal__content__form__group modal__content__form__group--col-3">
                      <a
                        className="modal__content__form__group__button modal__content__form__group__button--white"
                        data-micromodal-close
                      >
                        Cancelar
                      </a>
                    </div>
                    <div className="modal__content__form__group modal__content__form__group--col-3">
                      <a
                        className="modal__content__form__group__button "
                        onClick={(event) => this.ActionUserSupDesbloq(event)}
                      >
                        OK
                      </a>
                    </div>
                  </form>
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Groups);
